import { useContext } from "react";

import { TaskViewsContext } from "./TaskViewsContext";

export function useTaskViews() {
  const context = useContext(TaskViewsContext);
  if (!context) {
    throw new Error("useTaskViews must be used within a TaskViewsProvider");
  }
  return context;
}
